import {
    NUMERIC_METRICS,
    DEVICE_METRICS,
    HOST_METRICS,
    AGGREGATIONS,
    STATUS_AGGREGATIONS,
    OPERATORS,
    STATUS_OPERATORS,
} from './alarmRuleConstants';

/**
 * Validates all alarm rule form fields.
 * Returns an object with errors found (empty if all valid).
 */
export function validateAlarmRuleForm({ entityType, metric, aggregation, operator, threshold }) {
    const errors = {};

    if (!entityType) {
        errors.entityType = 'Entity type is required';
    }
    if (!metric) {
        errors.metric = 'Metric is required';
    }
    if (!aggregation) {
        errors.aggregation = 'Aggregation is required';
    }
    if (!operator) {
        errors.operator = 'Operator is required';
    }
    if (threshold === null || threshold === undefined || String(threshold).trim().length === 0) {
        errors.threshold = 'Threshold is required';
    } else if (metric && NUMERIC_METRICS.includes(metric.value) && !Number.isFinite(Number(threshold))) {
        errors.threshold = 'Threshold must be a numeric value for this metric';
    }

    return errors;
}

/**
 * Returns whether all required form fields are valid.
 */
export function isFormValid({ entityType, metric, aggregation, operator, threshold }) {
    const errors = validateAlarmRuleForm({ entityType, metric, aggregation, operator, threshold });
    return Object.keys(errors).length === 0;
}

/**
 * Checks if a rule already exists in the list (excluding a given index for edit mode).
 */
export function isDuplicateRule(newRule, existingRules, excludeIndex = -1) {
    return existingRules.some((rule, index) =>
        index !== excludeIndex &&
        rule.entityType === newRule.entityType &&
        rule.metric === newRule.metric &&
        rule.aggregation === newRule.aggregation &&
        rule.operator === newRule.operator &&
        String(rule.threshold) === String(newRule.threshold)
    );
}

/**
 * Checks if a rule with the same entityType + metric + aggregation already exists.
 * Only one condition per aggregation is allowed.
 */
export function isDuplicateAggregation(newRule, existingRules, excludeIndex = -1) {
    return existingRules.some((rule, index) =>
        index !== excludeIndex &&
        rule.entityType === newRule.entityType &&
        rule.metric === newRule.metric &&
        rule.aggregation === newRule.aggregation
    );
}

/**
 * Returns the available metrics for the given entity type.
 */
export function getMetricsForEntityType(entityType) {
    if (entityType === 'Device') return DEVICE_METRICS;
    if (entityType === 'Host') return HOST_METRICS;
    return [];
}

/**
 * Returns the available operators for the selected metric.
 * Status metrics only allow equals/not equals.
 */
export function getOperatorsForMetric(metric) {
    if (!metric) return OPERATORS;
    return NUMERIC_METRICS.includes(metric.value) ? OPERATORS : STATUS_OPERATORS;
}

/**
 * Returns the available aggregations for the selected metric.
 * Status metrics only allow "latest".
 */
export function getAggregationsForMetric(metric) {
    if (!metric) return AGGREGATIONS;
    return NUMERIC_METRICS.includes(metric.value) ? AGGREGATIONS : STATUS_AGGREGATIONS;
}
